import React, { Component } from "react";
import { withNamespaces } from "react-i18next";
import { connect } from "react-redux";
import Auxiliary from "../../../hoc/Auxiliary/Auxiliary";
import { isDesktop } from "react-device-detect";
import { Fade } from "react-awesome-reveal";
import Modal from "react-modal";
import { findDOMNode } from "react-dom";

// Icons
import { Icon } from "@iconify/react";

// Components
import DataTable from "../../../components/Datatable/DataTable";
import { getHistory, getHistoryByTransaction } from '../../../store/ducks/instantRebate/actions';

class History extends Component {
    constructor(props) {
      super(props);
      this.state = {
        showTxnModal: false,
        txnLoading: false,
        txnRows: [],
        txnId: null,
        txnPagination: { current_page: 1, per_page: 10, total_record: 0 },
        txn: { activePage: 1, limit: 10, loading: false, data: [] },
        txnHasMore: true, // NEW
      };
      this.txnTableRef = React.createRef();
    }

    componentDidMount() {
      const { start_date, end_date } = this.props;
      this.props.getHistory({
      activePage: this.props.pagination?.current_page || 1,
      limit: this.props.pagination?.per_page || 10,
      start_date,
      end_date,
      member_id: this.props.member_id,
      merchant_id: this.props.merchant_id,
      country_id: this.props.country_id,
      });
    }

    openTxnModal = async (transactionId) => {
      if (!transactionId || transactionId === '-') return;
      const { member_id, merchant_id, country_id } = this.props;

      this.setState({
        showTxnModal: true,
        txnLoading: true,
        txnRows: [],
        txnId: transactionId,
        txn: { activePage: 1, limit: 10, loading: true },
        txnHasMore: true,
    });

    try {
      const res = await this.props.getHistoryByTransaction({
        transaction_id: transactionId,
        member_id,
        merchant_id,
        country_id,
        activePage: 1,
        limit: 10,
      });

      const rows = res?.data?.result?.row || [];
      const pagination = res?.data?.result?.pagination || { current_page: 1, per_page: 10, total_record: 0 };
      const hasMore = rows.length < pagination.total_record;

      this.setState({
        txnRows: rows,
        txnPagination: pagination,
        txnLoading: false,
        txn: { activePage: 1, limit: 10, loading: false },
        txnHasMore: hasMore,
      });
  } catch (e) {
    this.setState({
      txnRows: [],
      txnPagination: { current_page: 1, per_page: 0, total_record: 0 },
      txnLoading: false,
      txn: { activePage: 1, limit: 10, loading: false },
      txnHasMore: false,
    });
    }
    };

    closeTxnModal = () => this.setState({ showTxnModal: false, txnRows: [], txnId: null });

    datatablesChangeHandler = (val, tab, act) => {
      if (tab !== 'txn') return;

      const newVal = act === 'searchValue' ? val.target.value : val;

      this.setState(
        (prev) => {
          const prevTab = prev[tab] || { activePage: 1, limit: 10 };
          return { [tab]: { ...prevTab, [act]: newVal, loading: true } };
        },
        () => {
          const { txnId } = this.state;
          const { member_id, merchant_id, country_id } = this.props;
          const { activePage, limit } = this.state.txn;

          this.props.getHistoryByTransaction({
            transaction_id: txnId,
            member_id,
            merchant_id,
            country_id,
            activePage: activePage || 1,
            limit: limit || 10,
          })
          .then((res) => {
            const data = res?.data || {};
            const rows = data.result?.row || [];
            const pagination = data.result?.pagination || { current_page: 1, per_page: 10, total_record: 0 };
            this.setState({
              txnRows: rows,
              txnPagination: pagination,
              txn: { ...this.state.txn, loading: false },
            });
          })
          .catch(() => this.setState({ txn: { ...this.state.txn, loading: false } }));
        }
      );
    };

    handleTxnTableScroll = async (e) => {
        const { txnLoading, txnHasMore, txnRows, txnPagination, txnId } = this.state;
        if (txnLoading || !txnHasMore) return;

        const target = e.target;
        if (target.scrollHeight - target.scrollTop - target.clientHeight < 50) {
          // Near bottom
          const nextPage = txnPagination.current_page + 1;
          const { member_id, merchant_id, country_id } = this.props;

          this.setState({ txnLoading: true });

          try {
            const res = await this.props.getHistoryByTransaction({
              transaction_id: txnId,
              member_id,
              merchant_id,
              country_id,
              activePage: nextPage,
              limit: 10,
            });

            const newRows = res?.data?.result?.row || [];
            const pagination = res?.data?.result?.pagination || txnPagination;
            const allRows = [...txnRows, ...newRows];
            const hasMore = allRows.length < pagination.total_record;

            this.setState({
              txnRows: allRows,
              txnPagination: { ...pagination, current_page: nextPage },
              txnLoading: false,
              txnHasMore: hasMore,
            });
        } catch (e) {
          this.setState({ txnLoading: false });
        }
      }
    };

    attachRefToBootstrapTable = () => {
      if (this.txnTableRef && this.txnTableRef.current) {
        const domNode = findDOMNode(this.txnTableRef.current);
        if (domNode) {
          const tableDiv = domNode.querySelector('.react-bootstrap-table');
          if (tableDiv) {
            this.txnTableDiv = tableDiv;
          }
        }
      }
    };

    componentDidUpdate(prevProps, prevState) {
      if (this.state.showTxnModal && this.txnTableRef.current) {
        this.attachRefToBootstrapTable();
        if (this.txnTableDiv) {
          this.txnTableDiv.removeEventListener('scroll', this.handleTxnTableScroll);
          this.txnTableDiv.addEventListener('scroll', this.handleTxnTableScroll);
        }
      }
    }

    render() {
        const { t } = this.props;
        
        const txnColumns = [
            { text: t("instant-rebate.rebate-date"), dataField: "update_date" },
            { text: t("instant-rebate.category"), dataField: "category",
                formatter: (cell, row) => t(`game-type.${row.category || ""}`)
            },
            { text: t("instant-rebate.provider"), dataField: "gameVendorSlug",
                formatter: (cell, row) => t(`vendor.${row.gameVendorSlug || ""}`)
            },
            { text: t("instant-rebate.valid-bet"), dataField: "turnover" },
            { text: t("instant-rebate.rebate-rate"), dataField: "rebate_rate" },
            { text: t("instant-rebate.rebate-earned"), dataField: "instant_rebate" },
        ];
        
        let rsData = [];
        const rows = (this.props.rows || []).map((r) => ({
            id: r.id,
            transaction_date: r.update_date, // Transaction Date
            transaction_id: r.transaction_id ?? '-', // Transaction ID (may be null now)
            rebate_period: `${r.rebate_period_startdate} - ${r.rebate_period_enddate}`,
            total_valid_bet: Number(r.total_valid_bet || 0),
            amount: Number(r.credit || 0),
        }));

        const columns = [
          { text: t("instant-rebate.transaction-date"), dataField: "transaction_date" },
          {
              text: t("instant-rebate.transaction-id"),
              dataField: "transaction_id",
              formatter: (cell) =>
                  cell && cell !== "-"
                      ? ( 
                          <button
                              type="button"
                              className="btn btn-link p-0"
                              onClick={() => this.openTxnModal(cell)}
                          >
                              {cell}
                          </button>
                      )
                      : "-",
          },
          { text: t("instant-rebate.rebate-period"), dataField: "rebate_period" },
          { text: t("instant-rebate.total-valid-bet"), dataField: "total_valid_bet" },
          { text: t("instant-rebate.amount"), dataField: "amount" },
        ];

        const txnRows = Array.isArray(this.state?.txnRows) ? this.state.txnRows : [];
        const txnLimit = txnRows.length > 0 ? txnRows.length : 1;

        return (
            <Auxiliary>
              <Fade duration={1000} triggerOnce>
                <DataTable
                  keyField="no"
                  data={rows}
                  columns={columns}
                  activePage={this.props.pagination?.current_page || 1}
                  limit={this.props.pagination?.per_page || 10}
                  totalItems={this.props.pagination?.total_record || 0}
                  paginationHandler={(val) => this.props.datatablesChangeHandler(val, this.props.tabName, "activePage")}
                  sizePerPageHandler={(val) => this.props.datatablesChangeHandler(val, this.props.tabName, "limit")}
                  loading={false}
                  hideSearchBar={true}
                  hideTotalRecords={true}
                  classValue="pd-table"
                  component="betting-history"
              />
            </Fade>
            <Modal
                isOpen={this.state.showTxnModal}
                closeTimeoutMS={500}
                portalClassName={`global-modal instant-rebate-history`}
                className="modal modal-dialog modal-dialog-centered modal-pd"
                ariaHideApp={false}
                onRequestClose={this.closeTxnModal}
              >
                <div className="modal-content">
                  <div className="modal-header">
                      <h5 className="modal-title">{t("instant-rebate.transaction-id")} #{this.state.txnId}</h5>
                      <Icon type="button" className="btn-close" icon="mdi:close" onClick={this.closeTxnModal} />
                  </div>
                  <div className="modal-body" ref={this.txnTableRef}>
                    <DataTable
                      keyField="no"
                      data={txnRows}
                      columns={txnColumns}
                      activePage={1}
                      limit={txnRows.length}
                      totalItems={this.state.txnPagination.total_record}
                      paginationHandler={() => {}}
                      sizePerPageHandler={() => {}}
                      hidePagination={true}
                      hideSearchBar={true}
                      hideTotalRecords={true}
                      classValue="pd-table"
                      component="transaction-history"
                      loading={this.state?.txn?.loading || this.state?.txnLoading || false}
                    />
                    {this.state.txnLoading && (
                      <div className="text-center">
                        <span>Loading...</span>
                      </div>
                    )}
                  </div>
              </div>
            </Modal>
          </Auxiliary>
        );
    }
}

const mapStateToProps = (state) => {
  const slice = state.instantRebate.history || {};
  const data = slice.data || {};
  return {
    rows: data.result?.row || [],
    pagination: data.result?.pagination || {},
    member_id: state.currentUser?.id,
    merchant_id: state.currentUser?.merchant_id,
    country_id: state.currentUser?.country_id,
  };
};

const mapDispatchToProps = (dispatch) => ({
    getHistory: (props) => dispatch(getHistory(props)),
    getHistoryByTransaction: (props) => dispatch(getHistoryByTransaction(props)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces("translation")(History));
